module.exports = __webpack_public_path__ + "img/BlinkArt_Sword13_Orange.3a168741.png";